"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoContent = void 0;
const languageUtils_1 = require("../languageUtils");
// NOTE: Record<keys, values>
const videoInfo = {
    en: {
        new: 'new',
        title: 'videos',
        trailers: 'trailers',
        trailerAnnouncement: 'https://www.youtube.com/watch?v=GdVh2wTacdg?autoplay=1',
        trailerNameAnnouncement: 'Announcement Trailer',
        trailerLinkStory: 'https://www.youtube.com/watch?v=1PBUqSBwyWE?autoplay=1',
        trailerNameStory: 'Story Trailer',
        trailerLinkCombat: 'https://www.youtube.com/watch?v=nOJJz9FG4m4?autoplay=1',
        trailerNameCombat: 'Combat Basics',
        trailerLinkCustomization: 'https://www.youtube.com/watch?v=OS1nNHfeB60?autoplay=1',
        trailerNameCustomization: 'Customization',
        trailerLinkParticles: 'https://www.youtube.com/watch?v=hT2UsbvWeys?autoplay=1',
        trailerNameParticles: 'Particle Weapons',
        trailerLinkDevDiary: 'https://www.youtube.com/watch?v=WDWIvQgC41w?autoplay=1',
        trailerNameDevDiary: 'See Behind The Scenes: Dev Diary',
        trailerLinkHeavyArmor: 'https://www.youtube.com/watch?v=FZGFh8HHEjI?autoplay=1',
        trailerNameHeavyArmor: 'Heavy Armor',
        trailerLinkFusion: 'https://www.youtube.com/watch?v=iSXGKlruTww?autoplay=1',
        trailerNameFusion: 'Fusion',
        trailerLinkNeun: 'https://www.youtube.com/watch?v=Y_12u5e5dWs?autoplay=1',
        trailerNameNeun: 'The Neun',
        trailerLinkReclaimers: 'https://www.youtube.com/watch?v=HZlr_QfF_dk?autoplay=1',
        trailerNameReclaimers: 'The Reclaimers',
        trailerLinkDemo: 'https://www.youtube.com/watch?v=se1nGtkrfkc?autoplay=1',
        trailerNameDemo: 'Demo announce trailer',
        trailerLinkColiseum: 'https://www.youtube.com/watch?v=aeXexeKGH84?autoplay=1',
        trailerNameColiseum: 'Coliseum',
        trailerLinkMissions: 'https://www.youtube.com/watch?v=p5TkdDi-uY0?autoplay=1',
        trailerNameMissions: 'Side Missions & Exploration',
        trailerLinkFacilities: 'https://www.youtube.com/watch?v=H_Onqn8fNoI?autoplay=1',
        trailerNameFacilities: 'Sovereign Axiom Facilities',
        trailerLinkLaunch: 'https://www.youtube.com/watch?v=u4DXz3UCOyA?autoplay=1',
        trailerNameLaunch: 'Launch Trailer',
        trailerLinkAbyss: 'https://www.youtube.com/watch?v=sETogXvxgRM?autoplay=1',
        trailerNameAbyss: 'Into the Abyss Expansion Trailer',
    },
    ca: {
        new: 'new',
        title: 'videos',
        trailers: 'trailers',
        trailerAnnouncement: 'https://www.youtube.com/watch?v=GdVh2wTacdg?autoplay=1',
        trailerNameAnnouncement: 'Announcement Trailer',
        trailerLinkStory: 'https://www.youtube.com/watch?v=1PBUqSBwyWE?autoplay=1',
        trailerNameStory: 'Story Trailer',
        trailerLinkCombat: 'https://www.youtube.com/watch?v=nOJJz9FG4m4?autoplay=1',
        trailerNameCombat: 'Combat Basics',
        trailerLinkCustomization: 'https://www.youtube.com/watch?v=OS1nNHfeB60?autoplay=1',
        trailerNameCustomization: 'Customization',
        trailerLinkParticles: 'https://www.youtube.com/watch?v=hT2UsbvWeys?autoplay=1',
        trailerNameParticles: 'Particle Weapons',
        trailerLinkDevDiary: 'https://www.youtube.com/watch?v=WDWIvQgC41w?autoplay=1',
        trailerNameDevDiary: 'See Behind The Scenes: Dev Diary',
        trailerLinkHeavyArmor: 'https://www.youtube.com/watch?v=FZGFh8HHEjI?autoplay=1',
        trailerNameHeavyArmor: 'Heavy Armor',
        trailerLinkFusion: 'https://www.youtube.com/watch?v=iSXGKlruTww?autoplay=1',
        trailerNameFusion: 'Fusion',
        trailerLinkNeun: 'https://www.youtube.com/watch?v=Y_12u5e5dWs?autoplay=1',
        trailerNameNeun: 'The Neun',
        trailerLinkReclaimers: 'https://www.youtube.com/watch?v=HZlr_QfF_dk?autoplay=1',
        trailerNameReclaimers: 'The Reclaimers',
        trailerLinkDemo: 'https://www.youtube.com/watch?v=se1nGtkrfkc?autoplay=1',
        trailerNameDemo: 'Demo announce trailer',
        trailerLinkColiseum: 'https://www.youtube.com/watch?v=aeXexeKGH84?autoplay=1',
        trailerNameColiseum: 'Coliseum',
        trailerLinkMissions: 'https://www.youtube.com/watch?v=p5TkdDi-uY0?autoplay=1',
        trailerNameMissions: 'Side Missions & Exploration',
        trailerLinkFacilities: 'https://www.youtube.com/watch?v=H_Onqn8fNoI?autoplay=1',
        trailerNameFacilities: 'Sovereign Axiom Facilities',
        trailerLinkLaunch: 'https://www.youtube.com/watch?v=u4DXz3UCOyA?autoplay=1',
        trailerNameLaunch: 'Launch Trailer',
        trailerLinkAbyss: 'https://www.youtube.com/watch?v=sETogXvxgRM?autoplay=1',
        trailerNameAbyss: 'Into the Abyss Expansion Trailer',
    },
    au: {
        new: 'new',
        title: 'videos',
        trailers: 'trailers',
        trailerAnnouncement: 'https://www.youtube.com/watch?v=O0USA3oKgsI?autoplay=1',
        trailerNameAnnouncement: 'Announcement Trailer',
        trailerLinkStory: 'https://www.youtube.com/watch?v=P_U00rh2G3o?autoplay=1',
        trailerNameStory: 'Story Trailer',
        trailerLinkCombat: 'https://www.youtube.com/watch?v=nOJJz9FG4m4?autoplay=1',
        trailerNameCombat: 'Combat Basics',
        trailerLinkCustomization: 'https://www.youtube.com/watch?v=_6eYfQpEKps?autoplay=1',
        trailerNameCustomization: 'Customization',
        trailerLinkParticles: 'https://www.youtube.com/watch?v=OzBZSEvPLYs?autoplay=1',
        trailerNameParticles: 'Particle Weapons',
        trailerLinkDevDiary: 'https://www.youtube.com/watch?v=uXYJFg5DWlE?autoplay=1',
        trailerNameDevDiary: 'See Behind The Scenes: Dev Diary',
        trailerLinkHeavyArmor: 'https://www.youtube.com/watch?v=FZGFh8HHEjI?autoplay=1',
        trailerNameHeavyArmor: 'Heavy Armor',
        trailerLinkFusion: 'https://www.youtube.com/watch?v=iSXGKlruTww?autoplay=1',
        trailerNameFusion: 'Fusion',
        trailerLinkNeun: 'https://www.youtube.com/watch?v=Y_12u5e5dWs?autoplay=1',
        trailerNameNeun: 'The Neun',
        trailerLinkReclaimers: 'https://www.youtube.com/watch?v=HZlr_QfF_dk?autoplay=1',
        trailerNameReclaimers: 'The Reclaimers',
        trailerLinkDemo: 'https://www.youtube.com/watch?v=f7dZAVGbopM?autoplay=1',
        trailerNameDemo: 'Demo announce trailer',
        trailerLinkColiseum: 'https://www.youtube.com/watch?v=t_YjibB3PY4?autoplay=1',
        trailerNameColiseum: 'Coliseum',
        trailerLinkMissions: 'https://www.youtube.com/watch?v=AaBvntxEWcs?autoplay=1',
        trailerNameMissions: 'Side Missions & Exploration',
        trailerLinkFacilities: 'https://www.youtube.com/watch?v=lSm_eOcpHEQ?autoplay=1',
        trailerNameFacilities: 'Sovereign Axiom Facilities',
        trailerLinkLaunch: 'https://www.youtube.com/watch?v=CBe1U4BWTc4?autoplay=1',
        trailerNameLaunch: 'Launch Trailer',
        trailerLinkAbyss: 'https://www.youtube.com/watch?v=dVr7FUzY0xI?autoplay=1',
        trailerNameAbyss: 'Into the Abyss Trailer',
    },
    nz: {
        new: 'new',
        title: 'videos',
        trailers: 'trailers',
        trailerAnnouncement: 'https://www.youtube.com/watch?v=O0USA3oKgsI?autoplay=1',
        trailerNameAnnouncement: 'Announcement Trailer',
        trailerLinkStory: 'https://www.youtube.com/watch?v=P_U00rh2G3o?autoplay=1',
        trailerNameStory: 'Story Trailer',
        trailerLinkCombat: 'https://www.youtube.com/watch?v=nOJJz9FG4m4?autoplay=1',
        trailerNameCombat: 'Combat Basics',
        trailerLinkCustomization: 'https://www.youtube.com/watch?v=_6eYfQpEKps?autoplay=1',
        trailerNameCustomization: 'Customization',
        trailerLinkParticles: 'https://www.youtube.com/watch?v=OzBZSEvPLYs?autoplay=1',
        trailerNameParticles: 'Particle Weapons',
        trailerLinkDevDiary: 'https://www.youtube.com/watch?v=uXYJFg5DWlE?autoplay=1',
        trailerNameDevDiary: 'See Behind The Scenes: Dev Diary',
        trailerLinkHeavyArmor: 'https://www.youtube.com/watch?v=FZGFh8HHEjI?autoplay=1',
        trailerNameHeavyArmor: 'Heavy Armor',
        trailerLinkFusion: 'https://www.youtube.com/watch?v=iSXGKlruTww?autoplay=1',
        trailerNameFusion: 'Fusion',
        trailerLinkNeun: 'https://www.youtube.com/watch?v=Y_12u5e5dWs?autoplay=1',
        trailerNameNeun: 'The Neun',
        trailerLinkReclaimers: 'https://www.youtube.com/watch?v=HZlr_QfF_dk?autoplay=1',
        trailerNameReclaimers: 'The Reclaimers',
        trailerLinkDemo: 'https://www.youtube.com/watch?v=f7dZAVGbopM?autoplay=1',
        trailerNameDemo: 'Demo announce trailer',
        trailerLinkColiseum: 'https://www.youtube.com/watch?v=t_YjibB3PY4?autoplay=1',
        trailerNameColiseum: 'Coliseum',
        trailerLinkMissions: 'https://www.youtube.com/watch?v=AaBvntxEWcs?autoplay=1',
        trailerNameMissions: 'Side Missions & Exploration',
        trailerLinkFacilities: 'https://www.youtube.com/watch?v=lSm_eOcpHEQ?autoplay=1',
        trailerNameFacilities: 'Sovereign Axiom Facilities',
        trailerLinkLaunch: 'https://www.youtube.com/watch?v=CBe1U4BWTc4?autoplay=1',
        trailerNameLaunch: 'Launch Trailer',
        trailerLinkAbyss: 'https://www.youtube.com/watch?v=dVr7FUzY0xI?autoplay=1',
        trailerNameAbyss: 'Into the Abyss Trailer',
    },
    uk: {
        new: 'new',
        title: 'videos',
        trailers: 'trailers',
        trailerAnnouncement: 'https://www.youtube.com/watch?v=O0USA3oKgsI?autoplay=1',
        trailerNameAnnouncement: 'Announcement Trailer',
        trailerLinkStory: 'https://www.youtube.com/watch?v=P_U00rh2G3o?autoplay=1',
        trailerNameStory: 'Story Trailer',
        trailerLinkCombat: 'https://www.youtube.com/watch?v=nOJJz9FG4m4?autoplay=1',
        trailerNameCombat: 'Combat Basics',
        trailerLinkCustomization: 'https://www.youtube.com/watch?v=_6eYfQpEKps?autoplay=1',
        trailerNameCustomization: 'Customization',
        trailerLinkParticles: 'https://www.youtube.com/watch?v=OzBZSEvPLYs?autoplay=1',
        trailerNameParticles: 'Particle Weapons',
        trailerLinkDevDiary: 'https://www.youtube.com/watch?v=uXYJFg5DWlE?autoplay=1',
        trailerNameDevDiary: 'See Behind The Scenes: Dev Diary',
        trailerLinkHeavyArmor: 'https://www.youtube.com/watch?v=FZGFh8HHEjI?autoplay=1',
        trailerNameHeavyArmor: 'Heavy Armor',
        trailerLinkFusion: 'https://www.youtube.com/watch?v=iSXGKlruTww?autoplay=1',
        trailerNameFusion: 'Fusion',
        trailerLinkNeun: 'https://www.youtube.com/watch?v=c_-wIs-HNH4 ?autoplay=1',
        trailerNameNeun: 'The Neun',
        trailerLinkReclaimers: 'https://www.youtube.com/watch?v=y0ELccb2bg8?autoplay=1',
        trailerNameReclaimers: 'The Reclaimers',
        trailerLinkDemo: 'https://www.youtube.com/watch?v=f7dZAVGbopM?autoplay=1',
        trailerNameDemo: 'Demo announce trailer',
        trailerLinkColiseum: 'https://www.youtube.com/watch?v=t_YjibB3PY4?autoplay=1',
        trailerNameColiseum: 'Coliseum',
        trailerLinkMissions: 'https://www.youtube.com/watch?v=AaBvntxEWcs?autoplay=1',
        trailerNameMissions: 'Side Missions & Exploration',
        trailerLinkFacilities: 'https://www.youtube.com/watch?v=lSm_eOcpHEQ?autoplay=1',
        trailerNameFacilities: 'Sovereign Axiom Facilities',
        trailerLinkLaunch: 'https://www.youtube.com/watch?v=CBe1U4BWTc4?autoplay=1',
        trailerNameLaunch: 'Launch Trailer',
        trailerLinkAbyss: 'https://www.youtube.com/watch?v=dVr7FUzY0xI?autoplay=1',
        trailerNameAbyss: 'Into the Abyss Trailer',
    },
    fr: {
        new: 'Nouveau',
        title: 'Vidéos',
        trailers: 'Bandes-annonces',
        trailerAnnouncement: 'https://www.youtube.com/watch?v=O0USA3oKgsI?autoplay=1',
        trailerNameAnnouncement: 'Première Bande-Annonce',
        trailerLinkStory: 'https://www.youtube.com/watch?v=QwQ_RPl53JU?autoplay=1',
        trailerNameStory: 'Bande-annonce Narrative',
        trailerLinkCombat: 'https://www.youtube.com/watch?v=L9m7FWMJGYc?autoplay=1',
        trailerNameCombat: 'Fondamentaux du Combat',
        trailerLinkCustomization: 'https://www.youtube.com/watch?v=M_wXPMgcbS8?autoplay=1',
        trailerNameCustomization: 'Personnalisation',
        trailerLinkParticles: 'https://www.youtube.com/watch?v=CG2a1h5IMRM?autoplay=1',
        trailerNameParticles: 'Armes à particules',
        trailerLinkDevDiary: 'https://www.youtube.com/watch?v=uXYJFg5DWlE?autoplay=1',
        trailerNameDevDiary: 'EN COULISSES : JOURNAL DES DÉVELOPPEURS',
        trailerLinkHeavyArmor: 'https://www.youtube.com/watch?v=eXZ8KZwG7j4?autoplay=1',
        trailerNameHeavyArmor: 'Méga Armure ',
        trailerLinkFusion: 'https://www.youtube.com/watch?v=IAOIv3p274E?autoplay=1',
        trailerNameFusion: 'Fusion',
        trailerLinkNeun: 'https://www.youtube.com/watch?v=xkPUETqs720?autoplay=1',
        trailerNameNeun: 'Les Neun',
        trailerLinkReclaimers: 'https://www.youtube.com/watch?v=Wuozalt2mL8?autoplay=1',
        trailerNameReclaimers: 'Les Reclaimers',
        trailerLinkDemo: 'https://www.youtube.com/watch?v=f7dZAVGbopM?autoplay=1',
        trailerNameDemo: 'Annonce de la démo',
        trailerLinkColiseum: 'https://www.youtube.com/watch?v=Vbne7eIOeTw?autoplay=1',
        trailerNameColiseum: 'Colisée',
        trailerLinkMissions: 'https://www.youtube.com/watch?v=-RfpU5p2UDo?autoplay=1',
        trailerNameMissions: 'Missions secondaires & Exploration',
        trailerLinkFacilities: 'https://www.youtube.com/watch?v=GU82caGz3QY?autoplay=1',
        trailerNameFacilities: "Les complexes de l'Axiome Souverain",
        trailerLinkLaunch: 'https://www.youtube.com/watch?v=CBe1U4BWTc4?autoplay=1',
        trailerNameLaunch: 'Bande-annonce de lancement',
        trailerLinkAbyss: 'https://www.youtube.com/watch?v=dVr7FUzY0xI?autoplay=1',
        trailerNameAbyss: 'Into the Abyss Bande-annonce',
    },
    de: {
        new: 'Neu',
        title: 'Videos',
        trailers: 'Trailer',
        trailerAnnouncement: 'https://www.youtube.com/watch?v=O0USA3oKgsI?autoplay=1',
        trailerNameAnnouncement: 'Ankündigungstrailer',
        trailerLinkStory: 'https://www.youtube.com/watch?v=aCgHw0_s1Pk?autoplay=1',
        trailerNameStory: 'Story-Trailer',
        trailerLinkCombat: 'https://www.youtube.com/watch?v=1SBiH_dkzEs?autoplay=1',
        trailerNameCombat: 'Kampfgrundlagen',
        trailerLinkCustomization: 'https://www.youtube.com/watch?v=kF1gaRS9Nrg?autoplay=1',
        trailerNameCustomization: 'Anpassung',
        trailerLinkParticles: 'https://www.youtube.com/watch?v=bxi5tx5ykI0?autoplay=1',
        trailerNameParticles: 'Partikelwaffen',
        trailerLinkDevDiary: 'https://www.youtube.com/watch?v=uXYJFg5DWlE?autoplay=1',
        trailerNameDevDiary: 'HINTER DEN KULISSEN: ENTWICKLERTAGEBUCH',
        trailerLinkHeavyArmor: 'https://www.youtube.com/watch?v=BvWZoePNoTg?autoplay=1',
        trailerNameHeavyArmor: 'Spezialrüstung',
        trailerLinkFusion: 'https://www.youtube.com/watch?v=qtTsq_NoI04?autoplay=1',
        trailerNameFusion: 'Fusion',
        trailerLinkNeun: 'https://www.youtube.com/watch?v=0m5_k61CLwU?autoplay=1',
        trailerNameNeun: 'Die Neun',
        trailerLinkReclaimers: 'https://www.youtube.com/watch?v=Qi-YjlHzPDg?autoplay=1',
        trailerNameReclaimers: 'Die Reclaimer',
        trailerLinkDemo: 'https://www.youtube.com/watch?v=f7dZAVGbopM?autoplay=1',
        trailerNameDemo: 'Demo-Ankündigung',
        trailerLinkColiseum: 'https://www.youtube.com/watch?v=jvhhP8aQhbQ?autoplay=1',
        trailerNameColiseum: 'Arena',
        trailerLinkMissions: 'https://www.youtube.com/watch?v=3GTgcZFem0k?autoplay=1',
        trailerNameMissions: 'Nebenmissionen & Erkundung',
        trailerLinkFacilities: 'https://www.youtube.com/watch?v=AIQPPO0pERo?autoplay=1',
        trailerNameFacilities: 'Souveränen Axiom Einrichtungen',
        trailerLinkLaunch: 'https://www.youtube.com/watch?v=CBe1U4BWTc4?autoplay=1',
        trailerNameLaunch: 'Launch Trailer',
        trailerLinkAbyss: 'https://www.youtube.com/watch?v=dVr7FUzY0xI?autoplay=1',
        trailerNameAbyss: 'In den Abgrund Trailer',
    },
    es: {
        new: 'Nuevo',
        title: 'Vídeos',
        trailers: 'Tráilers',
        trailerAnnouncement: 'https://www.youtube.com/watch?v=O0USA3oKgsI?autoplay=1',
        trailerNameAnnouncement: 'Tráiler de Anuncio',
        trailerLinkStory: 'https://www.youtube.com/watch?v=Zllcp9Egpqo?autoplay=1',
        trailerNameStory: 'Tráiler de la Historia',
        trailerLinkCombat: 'https://www.youtube.com/watch?v=fhVRRv8NBrE?autoplay=1',
        trailerNameCombat: 'Fundamentos del Combate',
        trailerLinkCustomization: 'https://www.youtube.com/watch?v=2Uzb9pCGEFQ?autoplay=1',
        trailerNameCustomization: 'Personalización',
        trailerLinkParticles: 'https://www.youtube.com/watch?v=44lJCnOdgO4?autoplay=1',
        trailerNameParticles: 'Armas de partículas',
        trailerLinkDevDiary: 'https://www.youtube.com/watch?v=uXYJFg5DWlE?autoplay=1',
        trailerNameDevDiary: 'ENTRE BASTIDORES: DIARIO DE DESARROLLO',
        trailerLinkHeavyArmor: 'https://www.youtube.com/watch?v=CdYOwg6eoYg?autoplay=1',
        trailerNameHeavyArmor: 'Armadura pesada',
        trailerLinkFusion: 'https://www.youtube.com/watch?v=jTCBWwvXNXA?autoplay=1',
        trailerNameFusion: 'Fusion',
        trailerLinkNeun: 'https://www.youtube.com/watch?v=ZIR12P_aTmI?autoplay=1',
        trailerNameNeun: 'Los Neun',
        trailerLinkReclaimers: 'https://www.youtube.com/watch?v=HBcFslVeyt0?autoplay=1',
        trailerNameReclaimers: 'Los Reclaimers',
        trailerLinkDemo: 'https://www.youtube.com/watch?v=f7dZAVGbopM?autoplay=1',
        trailerNameDemo: 'Anuncio de la demo',
        trailerLinkColiseum: 'https://www.youtube.com/watch?v=5AUB_wYwZWI?autoplay=1',
        trailerNameColiseum: 'Coliseo',
        trailerLinkMissions: 'https://www.youtube.com/watch?v=YK-o_rcn7hs?autoplay=1',
        trailerNameMissions: 'Misiones secundarias & Exploración',
        trailerLinkFacilities: 'https://www.youtube.com/watch?v=8vU9rs0hB90?autoplay=1',
        trailerNameFacilities: 'Las instalaciones de Sovereign Axiom',
        trailerLinkLaunch: 'https://www.youtube.com/watch?v=CBe1U4BWTc4?autoplay=1',
        trailerNameLaunch: 'Tráiler de lanzamiento',
        trailerLinkAbyss: 'https://www.youtube.com/watch?v=dVr7FUzY0xI?autoplay=1',
        trailerNameAbyss: 'Hacia el Abismo Tráiler',
    },
    it: {
        new: 'Nuovo',
        title: 'Video',
        trailers: 'Trailer',
        trailerAnnouncement: 'https://www.youtube.com/watch?v=O0USA3oKgsI?autoplay=1',
        trailerNameAnnouncement: 'Trailer di Annuncio',
        trailerLinkStory: 'https://www.youtube.com/watch?v=QwQ_RPl53JU?autoplay=1',
        trailerNameStory: 'Trailer della Storia',
        trailerLinkCombat: 'https://www.youtube.com/watch?v=PfpTFe7Kgeo?autoplay=1',
        trailerNameCombat: 'Fondamenti di Combattimento',
        trailerLinkCustomization: 'https://www.youtube.com/watch?v=qUJB887tEP4?autoplay=1',
        trailerNameCustomization: 'Personalizzazione',
        trailerLinkParticles: 'https://www.youtube.com/watch?v=W3cL853xKpI?autoplay=1',
        trailerNameParticles: 'Armi a particelle',
        trailerLinkDevDiary: 'https://www.youtube.com/watch?v=uXYJFg5DWlE?autoplay=1',
        trailerNameDevDiary: 'DIETRO LE QUINTE: DIARIO DEGLI SVILUPPATORI',
        trailerLinkHeavyArmor: 'https://www.youtube.com/watch?v=rYReMlbBAs8?autoplay=1',
        trailerNameHeavyArmor: 'Corazza pesante ',
        trailerLinkFusion: 'https://www.youtube.com/watch?v=t2fUhY8r02Y?autoplay=1',
        trailerNameFusion: 'Fusione',
        trailerLinkNeun: 'https://www.youtube.com/watch?v=uWpOiP1_fK8?autoplay=1',
        trailerNameNeun: 'I Neun',
        trailerLinkReclaimers: 'https://www.youtube.com/watch?v=uuWxCNUSPb8?autoplay=1',
        trailerNameReclaimers: 'Gli Reclaimers',
        trailerLinkDemo: 'https://www.youtube.com/watch?v=f7dZAVGbopM?autoplay=1',
        trailerNameDemo: 'Demo Annuncio',
        trailerLinkColiseum: 'https://www.youtube.com/watch?v=FppF2d-L2sA?autoplay=1',
        trailerNameColiseum: 'Kolosseum',
        trailerLinkMissions: 'https://www.youtube.com/watch?v=dlgzTOMsqZk?autoplay=1',
        trailerNameMissions: 'Missioni secondarie & Esplorazione',
        trailerLinkFacilities: 'https://www.youtube.com/watch?v=6E8Yes-8zbA?autoplay=1',
        trailerNameFacilities: 'le strutture del Sovereign Axiom',
        trailerLinkLaunch: 'https://www.youtube.com/watch?v=CBe1U4BWTc4?autoplay=1',
        trailerNameLaunch: 'Trailer Lancio',
        trailerLinkAbyss: 'https://www.youtube.com/watch?v=dVr7FUzY0xI?autoplay=1',
        trailerNameAbyss: "Nell'abisso Trailer",
    },
    pt: {
        new: 'Novo',
        title: 'Vídeos',
        trailers: 'Trailers',
        trailerAnnouncement: 'https://www.youtube.com/watch?v=O0USA3oKgsI?autoplay=1',
        trailerNameAnnouncement: 'Trailer de Anúncio',
        trailerLinkStory: 'https://www.youtube.com/watch?v=P_U00rh2G3o?autoplay=1',
        trailerNameStory: 'Trailer da História',
        trailerLinkCombat: 'https://www.youtube.com/watch?v=QNs0jh_Z5k?autoplay=1',
        trailerNameCombat: 'Fundamentos do combate',
        trailerLinkCustomization: 'https://www.youtube.com/watch?v=_6eYfQpEKps?autoplay=1',
        trailerNameCustomization: 'Personalização',
        trailerLinkParticles: 'https://www.youtube.com/watch?v=OzBZSEvPLYs?autoplay=1',
        trailerNameParticles: 'Armas de partículas',
        trailerLinkDevDiary: 'https://www.youtube.com/watch?v=uXYJFg5DWlE?autoplay=1',
        trailerNameDevDiary: 'NOS BASTIDORES: DIÁRIO DE DESENVOLVIMENTO',
        trailerLinkHeavyArmor: 'https://www.youtube.com/watch?v=FZGFh8HHEjI?autoplay=1',
        trailerNameHeavyArmor: 'Armadura pesada',
        trailerLinkFusion: 'https://www.youtube.com/watch?v=iSXGKlruTww?autoplay=1',
        trailerNameFusion: 'Fusione',
        trailerLinkNeun: 'https://www.youtube.com/watch?v=c_-wIs-HNH4?autoplay=1',
        trailerNameNeun: 'Os Neun',
        trailerLinkReclaimers: 'https://www.youtube.com/watch?v=y0ELccb2bg8?autoplay=1',
        trailerNameReclaimers: 'Os Reclaimers',
        trailerLinkDemo: 'https://www.youtube.com/watch?v=f7dZAVGbopM?autoplay=1',
        trailerNameDemo: 'Anúncio de demo',
        trailerLinkColiseum: 'https://www.youtube.com/watch?v=t_YjibB3PY4?autoplay=1',
        trailerNameColiseum: 'Coliseu',
        trailerLinkMissions: 'https://www.youtube.com/watch?v=AaBvntxEWcs?autoplay=1',
        trailerNameMissions: 'Missões secundárias & exploração',
        trailerLinkFacilities: 'https://www.youtube.com/watch?v=lSm_eOcpHEQ?autoplay=1',
        trailerNameFacilities: 'Instalações da Axioma Soberano',
        trailerLinkLaunch: 'https://www.youtube.com/watch?v=CBe1U4BWTc4?autoplay=1',
        trailerNameLaunch: 'Trailer de Lançamento',
        trailerLinkAbyss: 'https://www.youtube.com/watch?v=dVr7FUzY0xI?autoplay=1',
        trailerNameAbyss: 'Into the Abyss Trailer',
    },
    nl: {
        new: 'Nieuw',
        title: 'Videos',
        trailers: 'Aanhangwagens',
        trailerAnnouncement: 'https://www.youtube.com/watch?v=O0USA3oKgsI?autoplay=1',
        trailerNameAnnouncement: 'Aankondigingstrailer',
        trailerLinkStory: 'https://www.youtube.com/watch?v=P_U00rh2G3o?autoplay=1',
        trailerNameStory: 'Verhaaltrailer',
        trailerLinkCombat: 'https://www.youtube.com/watch?v=QNs0jh_Z5k?autoplay=1',
        trailerNameCombat: 'Combat Basics',
        trailerLinkCustomization: 'https://www.youtube.com/watch?v=_6eYfQpEKps?autoplay=1',
        trailerNameCustomization: 'Aanpassing',
        trailerLinkParticles: 'https://www.youtube.com/watch?v=OzBZSEvPLYs?autoplay=1',
        trailerNameParticles: 'Deeltjeswapens',
        trailerLinkDevDiary: 'https://www.youtube.com/watch?v=uXYJFg5DWlE?autoplay=1',
        trailerNameDevDiary: 'ACHTER DE SCHERMEN: DEV DIARY',
        trailerLinkHeavyArmor: 'https://www.youtube.com/watch?v=FZGFh8HHEjI?autoplay=1',
        trailerNameHeavyArmor: 'Zware pantsering',
        trailerLinkFusion: 'https://www.youtube.com/watch?v=iSXGKlruTww?autoplay=1',
        trailerNameFusion: 'Fusione',
        trailerLinkNeun: 'https://www.youtube.com/watch?v=c_-wIs-HNH4?autoplay=1',
        trailerNameNeun: 'De Neun',
        trailerLinkReclaimers: 'https://www.youtube.com/watch?v=y0ELccb2bg8?autoplay=1',
        trailerNameReclaimers: 'De Reclaimers',
        trailerLinkDemo: 'https://www.youtube.com/watch?v=f7dZAVGbopM?autoplay=1',
        trailerNameDemo: 'Demo Aankondiging',
        trailerLinkColiseum: 'https://www.youtube.com/watch?v=t_YjibB3PY4?autoplay=1',
        trailerNameColiseum: 'Colosseum',
        trailerLinkMissions: 'https://www.youtube.com/watch?v=AaBvntxEWcs?autoplay=1',
        trailerNameMissions: 'Zijmissies & Verkenning',
        trailerLinkFacilities: 'https://www.youtube.com/watch?v=lSm_eOcpHEQ?autoplay=1',
        trailerNameFacilities: 'Soevereine Axioma-faciliteiten',
        trailerLinkLaunch: 'https://www.youtube.com/watch?v=CBe1U4BWTc4?autoplay=1',
        trailerNameLaunch: 'Lanceringstrailer',
        trailerLinkAbyss: 'https://www.youtube.com/watch?v=dVr7FUzY0xI?autoplay=1',
        trailerNameAbyss: 'In de Leegte Trailer',
    },
};
class videoContent {
    constructor() {
        this.title = document.querySelector('.videosTitle');
        this.trailers = document.querySelector('.trailersText');
        this.trailerAnnouncment = document.querySelector('.trailer__announcement');
        this.new = document.querySelectorAll('.newText');
        this.trailerLinkStory = document.querySelector('.trailerLinkStory');
        this.trailerNameStory = document.querySelector('.trailerNameStory');
        this.trailerNameAnnouncementText = document.querySelector('.trailerNameAnnouncementText');
        this.trailerLinkCombat = document.querySelector('.trailerLinkCombat');
        this.trailerNameCombat = document.querySelector('.trailerNameCombat');
        this.trailerLinkCustomization = document.querySelector('.trailerLinkCustomization');
        this.trailerNameCustomization = document.querySelector('.trailerNameCustomization');
        this.trailerLinkParticles = document.querySelector('.trailerLinkParticles');
        this.trailerNameParticles = document.querySelector('.trailerNameParticles');
        this.trailerLinkDevDiary = document.querySelector('.trailerLinkDevDiary');
        this.trailerNameDevDiary = document.querySelector('.trailerNameDevDiary');
        this.trailerLinkHeavyArmor = document.querySelector('.trailerLinkHeavyArmor');
        this.trailerNameHeavyArmor = document.querySelector('.trailerNameHeavyArmor');
        this.trailerLinkFusion = document.querySelector('.trailerLinkFusion');
        this.trailerNameFusion = document.querySelector('.trailerNameFusion');
        this.trailerLinkNeun = document.querySelector('.trailerLinkNeun');
        this.trailerNameNeun = document.querySelector('.trailerNameNeun');
        this.trailerLinkReclaimers = document.querySelector('.trailerLinkReclaimers');
        this.trailerNameReclaimers = document.querySelector('.trailerNameReclaimers');
        this.trailerLinkDemo = document.querySelector('.trailerLinkDemo');
        this.trailerNameDemo = document.querySelector('.trailerNameDemo');
        this.trailerLinkColiseum = document.querySelector('.trailerLinkColiseum');
        this.trailerNameColiseum = document.querySelector('.trailerNameColiseum');
        this.trailerLinkMissions = document.querySelector('.trailerLinkMissions');
        this.trailerNameMissions = document.querySelector('.trailerNameMissions');
        this.trailerLinkFacilities = document.querySelector('.trailerLinkFacilities');
        this.trailerNameFacilities = document.querySelector('.trailerNameFacilities');
        this.trailerLinkLaunch = document.querySelector('.trailerLinkLaunch');
        this.trailerNameLaunch = document.querySelector('.trailerNameLaunch');
        this.trailerLinkAbyss = document.querySelector('.trailerLinkAbyss');
        this.trailerNameAbyss = document.querySelector('.trailerNameAbyss');
        this.init();
    }
    init() {
        this.updateText();
    }
    updateText() {
        const language = (0, languageUtils_1.getLanguage)();
        const content = videoInfo[language] || videoInfo['en'];
        if (this.title)
            this.title.textContent = content.title.toUpperCase();
        if (this.trailers)
            this.trailers.textContent =
                content.trailers.charAt(0).toUpperCase() +
                    content.trailers.slice(1).toLowerCase();
        if (this.trailerAnnouncment)
            this.trailerAnnouncment.setAttribute('href', content.trailerAnnouncement);
        if (this.trailerLinkStory)
            this.trailerLinkStory.setAttribute('href', content.trailerLinkStory);
        if (this.trailerLinkCombat)
            this.trailerLinkCombat.setAttribute('href', content.trailerLinkCombat);
        if (this.trailerLinkCustomization)
            this.trailerLinkCustomization.setAttribute('href', content.trailerLinkCustomization);
        if (this.trailerLinkParticles)
            this.trailerLinkParticles.setAttribute('href', content.trailerLinkParticles);
        if (this.trailerLinkDevDiary)
            this.trailerLinkDevDiary.setAttribute('href', content.trailerLinkDevDiary);
        if (this.trailerLinkHeavyArmor)
            this.trailerLinkHeavyArmor.setAttribute('href', content.trailerLinkHeavyArmor);
        if (this.trailerLinkFusion)
            this.trailerLinkFusion.setAttribute('href', content.trailerLinkFusion);
        if (this.trailerLinkNeun)
            this.trailerLinkNeun.setAttribute('href', content.trailerLinkNeun);
        if (this.trailerLinkReclaimers)
            this.trailerLinkReclaimers.setAttribute('href', content.trailerLinkReclaimers);
        if (this.trailerLinkDemo)
            this.trailerLinkDemo.setAttribute('href', content.trailerLinkDemo);
        if (this.trailerLinkColiseum)
            this.trailerLinkColiseum.setAttribute('href', content.trailerLinkColiseum);
        if (this.trailerLinkMissions)
            this.trailerLinkMissions.setAttribute('href', content.trailerLinkMissions);
        if (this.trailerLinkFacilities)
            this.trailerLinkFacilities.setAttribute('href', content.trailerLinkFacilities);
        if (this.trailerLinkLaunch)
            this.trailerLinkLaunch.setAttribute('href', content.trailerLinkLaunch);
        if (this.trailerLinkAbyss)
            this.trailerLinkAbyss.setAttribute('href', content.trailerLinkAbyss);
        if (this.trailerNameAnnouncementText)
            this.trailerNameAnnouncementText.textContent =
                content.trailerNameAnnouncement;
        if (this.trailerNameStory)
            this.trailerNameStory.textContent = content.trailerNameStory;
        if (this.trailerNameCombat)
            this.trailerNameCombat.textContent = content.trailerNameCombat;
        if (this.trailerNameCustomization)
            this.trailerNameCustomization.textContent =
                content.trailerNameCustomization;
        if (this.trailerNameParticles)
            this.trailerNameParticles.textContent = content.trailerNameParticles;
        if (this.trailerNameDevDiary)
            this.trailerNameDevDiary.textContent = content.trailerNameDevDiary;
        if (this.new)
            this.new.forEach(el => {
                el.textContent = content.new;
            });
        if (this.trailerNameHeavyArmor)
            this.trailerNameHeavyArmor.textContent = content.trailerNameHeavyArmor;
        if (this.trailerNameFusion)
            this.trailerNameFusion.textContent = content.trailerNameFusion;
        if (this.trailerNameNeun)
            this.trailerNameNeun.textContent = content.trailerNameNeun;
        if (this.trailerNameReclaimers)
            this.trailerNameReclaimers.textContent = content.trailerNameReclaimers;
        if (this.trailerNameDemo)
            this.trailerNameDemo.textContent = content.trailerNameDemo;
        if (this.trailerNameColiseum)
            this.trailerNameColiseum.textContent = content.trailerNameColiseum;
        if (this.trailerNameMissions)
            this.trailerNameMissions.textContent = content.trailerNameMissions;
        if (this.trailerNameFacilities)
            this.trailerNameFacilities.textContent = content.trailerNameFacilities;
        if (this.trailerNameMissions)
            this.trailerNameMissions.textContent = content.trailerNameMissions;
        if (this.trailerNameLaunch)
            this.trailerNameLaunch.textContent = content.trailerNameLaunch;
        if (this.trailerNameAbyss)
            this.trailerNameAbyss.textContent = content.trailerNameAbyss;
    }
}
exports.videoContent = videoContent;
